<template>
  <div ref="maindiv" id="addeditcontent">

    <vs-button
      id="back-to-topic_btn"
      @click="backToTopic"
      icon-pack="feather"
      icon="icon-arrow-left"
      class="float-left mb-3 school-primary_gradient glow-effect_tertiary">
      Back
    </vs-button>

    <div class="main-div">
      <div class="vx-row limit-width_fixed-scalable">
        <div style="margin:auto" class="mb-4">
          <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 400px">
            <vx-input-group>
              <vs-button
                :disabled="true"
                size="large"
                style="width: 400px; padding-right: 0 !important;"
                class="button__fully-opaque glow-effect_bg-color__blend header_button-lookalike text__school-font-color bg-color"
                type="filled"
                color="">
                Edit Upload
              </vs-button>
            </vx-input-group>
          </vx-card>

          <vx-card card-background="#11193f" class="glow-effect_dark limit-width_uploader card__no-padding">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="UploadCloudIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <file-pond
                id="filepond"
                ref="pond"
                :server="uploadLocation"
                label-idle="Drop <strong>REPLACEMENT UPLOAD</strong> here or <span class='filepond--label-action'>Browse</span>"
                :allow-multiple="false"
                :instant-upload="true"
                accepted-file-types="application/pdf, text/plain, application/msword, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/png, image/jpg, image/jpeg, image/gif, text/html, text/plain, application/msaccess,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
                :allow-image-preview="true"
                allowPaste=false
                @processfile="uploadComplete"
                @removefile="fileRemoved"
                :files="myFile"
              />
            </vx-input-group>
          </vx-card>
        </div>
      </div>

      <div>
        <div class="vx-row" id="documentdetails">
          <div class="vx-col pb-3 w-full sm:w-1/2 md:w-1/2">
            <label style="color:rgb(202, 202, 202);">Title of upload</label>
            <vs-input autocomplete="off" id="documentname" class="w-full" v-model="uploadName"/>
          </div>
          <div class="vx-col w-full sm:w-1/2 md:w-1/2">
            <label class="pl-4" style="color:rgb(202, 202, 202);">Description of upload</label>
            <vs-textarea id="documentDesc" class="" v-model="uploadDesc" />
          </div>
        </div>
      </div>

      <vx-card title="Configuration">
        <div class="vx-row mt-5">
          <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 sm:w-full xs:w-full">
            <vs-checkbox color="success" v-model="allowAudio" style="padding-bottom: 25px">Allow Audio</vs-checkbox>
          </div>
          <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 sm:w-full xs:w-full">
            <vs-checkbox color="success" v-model="allowDocument" style="padding-bottom: 25px">Allow Documents</vs-checkbox>
          </div>
          <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 sm:w-full xs:w-full">
            <vs-checkbox color="success" v-model="allowImage" style="padding-bottom: 25px">Allow Images</vs-checkbox>
          </div>
          <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 sm:w-full xs:w-full">
            <vs-checkbox color="success" v-model="allowVideo" style="padding-bottom: 25px">Allow Videos</vs-checkbox>
          </div>
          <vs-divider style="padding-bottom: 14px"></vs-divider>
          <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 sm:w-full xs:w-full">
            <vs-checkbox color="success" v-model="allowMultiple" style="padding-bottom: 25px">Allow Multiple Uploads</vs-checkbox>
          </div>
          <div class="vx-col xl:w-1/4 lg:w-1/3 md:w-1/2 sm:w-full xs:w-full">
            <vs-checkbox color="success" v-model="allowMultipleSubmissions" style="padding-bottom: 25px">Allow Multiple Submissions</vs-checkbox>
          </div>
        </div>
          <div v-if="$getSiteId() == 21">
            <div class="vx-row mt-5">
              <vs-divider></vs-divider>
              <vs-checkbox color="success" v-model="isClasswork" style="padding-bottom: 25px">Classwork</vs-checkbox>
              <vs-checkbox color="success" v-model="isAssessment" style="padding-bottom: 25px">Assessment</vs-checkbox>
            </div>
          </div>
          <div v-if="$siteTypeId() == 1">
            <vs-divider></vs-divider>
            <vs-button icon-pack="feather" icon="alert-triangle" type="flat" color="success" @click="scheduleVisibilityPopupActive= true"><strong>Manage Task Schedule and visibility</strong></vs-button>
          </div>
        
      </vx-card>

    </div>
    <locations
      :isLocationViewActive="isLocationViewActive"
      :selectedData="selectedData"
      :uploadedFileUrl="uploadedFileUrl"
      @save="save"
      :locationsProp="locations"
    />
    <vs-popup title="Choose Students From Classroom" :active.sync="viewClassroomPopup">
      <h4 v-if="students.studentsClassroomView && students.studentsClassroomView.filter(q=> q.classroomId == chosenClassroomId)[0]">{{students.studentsClassroomView.filter(q=> q.classroomId == chosenClassroomId)[0].classroomName}}</h4>
      <vs-divider border-style="dashed" />
      <vs-button @click="selectAllClass" type="flat" color="success" ><strong>Select All</strong></vs-button>
      <vs-button @click="unselectAllClass" type="flat" color="success" ><strong>Unselect All</strong></vs-button>
      <vs-button @click="switchSelectedClass" type="flat" color="success" ><strong>Switch selected</strong></vs-button>
      <vs-table 
        v-if=" students.studentsClassroomView && students.studentsClassroomView.filter(q=> q.classroomId == chosenClassroomId)[0]"
        ref="visibility-student-table" 
        single 
        max-items="10" 
        pagination 
        :data="students.studentsClassroomView.filter(q=> q.classroomId == chosenClassroomId)[0].students"
        search
      >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <h3>Students</h3>
        </div>
        <template slot="thead">
          <vs-th sort-key="name">Student Name</vs-th>
          <!-- <vs-th sort-key="courseName">Subject</vs-th> -->
          <vs-th >To Include</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :data="student" :key="studentInx" v-for="(student, studentInx) in data"> 

            <vs-td :data="data[studentInx].studentFullName">
              {{ student.studentFullName }}
            </vs-td> 

            <vs-td :data="data[studentInx]">
              <vs-checkbox v-model="student.checked" style="padding:5px">
              </vs-checkbox>
            </vs-td> 

          </vs-tr>
        </template>
        
      </vs-table>
    </vs-popup>
    <vs-popup id="schedule-visibility-popup" ref="schedulevisibilitypopup" title="Scheduling and visibility"  :active.sync="scheduleVisibilityPopupActive"> <!--// :active.sync="calendarPopupActive"-->
      <vs-tabs id="schedule-visibility-tab-container" v-model="activeTab">
        <vs-tab label="Scheduling">
          <div id="schedule-tab">
            <vs-checkbox color="success" v-model="useSchedulingFunctionality" style="padding-bottom: 25px">Use schedule functionality</vs-checkbox>
            <vs-divider border-style="dashed" />
            <div id="schedule-tab-container" v-if="useSchedulingFunctionality">
              <div id="date-pickers">
                <div class="time-date-picker-combo" style="display:flex;flex-direction:column;">
                  <h4>From Time:</h4>
                  <vx-input-group style="height: 50px;">
                    
                    <template slot="prepend">
                      <div class="prepend-text school-primary_gradient">
                        <span><feather-icon class="pt-1" icon="ClockIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>
                    
                    <vue-clock-picker
                      ref="streamEndTimePicker"
                      class="custom-classes__time-picker"
                      v-model="taskBeginTime"
                      close-on-esc
                      close-on-overlay
                      font="Montserrat"
                      done-text="Done"
                      cancel-text="Cancel"
                      active-color="primary"
                      color="#ffffff"
                    />
                    </vx-input-group>
                    <h4>From Date:</h4>
                  <datepicker ref="fromPicker" v-model="fromDate" :inline="true" :format="format" :highlighted="highlightedFn"></datepicker>
                </div>
                <div class="time-date-picker-combo">
                  <h4>To Time:</h4>
                  <vx-input-group style="height: 50px;">
                    
                    <template slot="prepend">
                      <div class="prepend-text school-primary_gradient">
                        <span><feather-icon class="pt-1" icon="ClockIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>
                    
                    <vue-clock-picker
                      ref="streamEndTimePicker"
                      class="custom-classes__time-picker"
                      v-model="taskEndTime"
                      close-on-esc
                      close-on-overlay
                      font="Montserrat"
                      done-text="Done"
                      cancel-text="Cancel"
                      active-color="#ecf01a"
                      color="#ffffff"
                    />
                  </vx-input-group>
                  <h4>To Date:</h4>
                  <datepicker ref="fromPicker" v-model="toDate" :inline="true" :format="format" :highlighted="highlightedFn"></datepicker>
                </div>
              </div>
            </div>
            
          </div>
        </vs-tab>
        <vs-tab label="Visibility">
          <vs-checkbox color="success" v-model="useVisibilityFunctionality" style="padding-bottom: 25px">Use visibility functionality</vs-checkbox>
          <vs-divider border-style="dashed" />
          <div v-if="useVisibilityFunctionality" ref="visibility-student-container">
            <vs-tabs id="schedule-visibility-tab-container" v-model="studentVisibilityActiveTab">
              <vs-tab label="Students By Grade">
                <vs-button @click="selectAllGrade" type="flat" color="success" ><strong>Select All</strong></vs-button>
                <vs-button @click="unselectAllGrade" type="flat" color="success" ><strong>Unselect All</strong></vs-button>
                <vs-button @click="switchSelectedGrade" type="flat" color="success" ><strong>Switch selected</strong></vs-button>
                <vs-table 
                  v-if="students.studentsGradeView"
                  ref="visibility-student-table" 
                  single 
                  max-items="10" 
                  pagination 
                  :data="students.studentsGradeView"
                  search 
                  
                >
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <h3>Students</h3>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="name">Student Name</vs-th>
                    <!-- <vs-th sort-key="courseName">Subject</vs-th> -->
                    <vs-th >To Include</vs-th>
                  </template>
                  <template slot-scope="{data}">
                    <vs-tr :data="student" :key="studentInx" v-for="(student, studentInx) in data"> 

                      <vs-td :data="data[studentInx].studentFullName">
                        {{ student.studentFullName }}
                      </vs-td> 

                      <vs-td :data="data[studentInx]">
                        <vs-checkbox v-model="student.checked" style="padding:5px">
                          
                        </vs-checkbox>
                      </vs-td> 

                    </vs-tr>
                  </template>
                  
                </vs-table>
              </vs-tab>
              <vs-tab label="Students By Classroom">
                <vs-table 
                  v-if="students.studentsClassroomView"
                  ref="visibility-student-table" 
                  single 
                  max-items="10" 
                  pagination 
                  :data="students.studentsClassroomView"
                  search 
                  @selected="handleClassroomClicked"
                >
                  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <h3>Students</h3>
                  </div>
                  <template slot="thead">
                    <vs-th sort-key="name">Classroom Name</vs-th>
                  </template>
                  <template slot-scope="{data}">
                    <vs-tr :data="student" :key="studentInx" v-for="(student, studentInx) in data"> 

                    <vs-td :data="data[studentInx].classroomName">
                      {{ student.classroomName }}
                    </vs-td> 

                    </vs-tr>
                  </template>
                  
                </vs-table>
              </vs-tab>
            </vs-tabs>
          </div>
        </vs-tab>
      </vs-tabs>
      <div style="display:flex;justify-content:center;" @click="scheduleVisibilityPopupActive = false" class="self-center pr-1">
        <vs-button type="flat" color="success" ><strong>OK</strong></vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

import Datepicker from 'vuejs-datepicker';
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component';
import VueClockPicker from '@pencilpix/vue2-clock-picker';
import '@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css';

import Locations from './Locations.vue';
import Divider from '../../../../views/components/vuesax/divider/Divider.vue';
export default {
  components: {
    FilePond,
    Locations,
    Divider,
    Datepicker,
    moment,
    flatPickr,
    VueClockPicker
  },
  data() {
    return {
      isLocationViewActive: true,
      myFile: [],
      uploadName: "",
      uploadDesc: "",
      selectedData: {},
      uploadedFileUrl: null,
      activePrompt: false,
      uploadTask: null,
      locations: [],
      isTeacher: false,
      documents: [],
      allowVideo: false,
      allowImage: false,
      allowDocument: false,
      allowAudio: false,
      allowMultiple: false,
      allowMultipleSubmissions: false,
      scheduleVisibilityPopupActive:false,
      useSchedulingFunctionality:false,
      useVisibilityFunctionality:false,
      fromDate: new Date(),
      toDate: new Date(),
      format: "yyyy-MM-dd",
      highlightedFn: {
        customPredictor(date) {
          var today = new Date();
          
          if (date.getDate() == today.getDate() && date.getMonth() == today.getMonth()) {
            return true;
          }
        }
      },
      activeTab: 0,
      studentVisibilityActiveTab:0,
      taskBeginTime: null,
      taskEndTime: null,
      students:[],
      viewClassroomPopup:false,
      chosenClassroomId:0,
      isAssessment:false,
      isClasswork:true,
    };
  },
  watch:{
    scheduleVisibilityPopupActive:function(val){
      var self = this;
      if(val){
        self.loadStudentsForVisibilityTable();
      }
    },
    isClasswork:function(val){
      var self = this;
      if(val){
        self.isAssessment=false;
      }else{
        self.isAssessment=true;
      }
    },
    isAssessment:function(val){
      var self = this;
      if(val){
        self.isClasswork=false;
      }else{
        self.isClasswork=true;
      }
    }
  },
  computed: {
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    },
  },
  methods: {
    initValues() {
      var self = this;
      self.documentName = "";
      self.documentDesc = "";
      self.uploadedFileUrl = "";
      self.allowVideo = false;
      self.allowImage = false;
      self.allowDocument = false;
      self.allowAudio = false;
      self.allowMultiple = false;
      self.allowMultipleSubmissions = false;
    },
    selectAllGrade(){
      var self = this;
      if(self.students.studentsGradeView){
        self.students.studentsGradeView.forEach(e => {
        e.checked = true;
      });
      }
    },
    unselectAllGrade(){
      var self = this;
      if(self.students.studentsGradeView){
        self.students.studentsGradeView.forEach(e => {
        e.checked = false;
      });
      }
    },
    switchSelectedGrade(){
      var self = this;
      if(self.students.studentsGradeView){
        self.students.studentsGradeView.forEach(e => {
        e.checked = !e.checked;
      });
      }
    },
    selectAllClass(){
      var self = this;
      if(self.students.studentsClassroomView && self.chosenClassroomId){
        self.students.studentsClassroomView.filter(q=> q.classroomId == self.chosenClassroomId)[0].students.forEach(e => {
        e.checked = true;
      });
      }
    },
    unselectAllClass(){
      var self = this;
      if(self.students.studentsClassroomView && self.chosenClassroomId){
        self.students.studentsClassroomView.filter(q=> q.classroomId == self.chosenClassroomId)[0].students.forEach(e => {
        e.checked = false;
      });
      }
    },
    switchSelectedClass(){
      var self = this;
      if(self.students.studentsClassroomView && self.chosenClassroomId){
        self.students.studentsClassroomView.filter(q=> q.classroomId == self.chosenClassroomId)[0].students.forEach(e => {
        e.checked = !e.checked;
      });
      }
    },
    uploadComplete(error, file) {
      var self = this;
      var response = JSON.parse(file.serverId);
      if(response.url){
        self.documents = [];
        self.uploadedFileUrl = response.url;

        self.documents.push({
          url : self.uploadedFileUrl
        });
      }
    },
    fileRemoved(error, file) {
      this.initValues();
    },
    save(allLocations) {
      var self = this;
      if(self.allowVideo || self.allowImage || self.allowDocument || self.allowAudio){
        if(self.uploadName && self.uploadDesc) {
        self.showLoadingOnElement('maindiv', 1, 'material');

        var uploadToAddInfo = {
          id: self.uploadTask.id,
          title: self.uploadName,
          name: self.uploadName,
          description: self.uploadDesc,
          documents: self.documents,
          modules: allLocations,
          content: self.uploadDesc,
          allowVideo: self.allowVideo,
          allowImage: self.allowImage,
          allowDocument: self.allowDocument,
          allowAudio: self.allowAudio,
          allowMultiple: self.allowMultiple,
          allowMultipleSubmissions: self.allowMultipleSubmissions,
          isAssessment: self.isAssessment,
          isClasswork: self.isClasswork
        };
        if(self.useSchedulingFunctionality){
          var scheduleObject = {
            scheduleInformation:{
              fromTime: self.taskBeginTime,
              toTime: self.taskEndTime,
              fromDate: moment(new Date(Date.parse(self.fromDate)).toISOString()).format(),
              toDate: moment(new Date(Date.parse(self.toDate)).toISOString()).format()
            }
          }
          uploadToAddInfo = Object.assign(uploadToAddInfo,scheduleObject);
        }
        if(self.useVisibilityFunctionality){
          var excludeObject = {
            studentInformation:self.students
          }
          uploadToAddInfo = Object.assign(uploadToAddInfo,excludeObject);
        }

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `Upload saved to ${allLocations.length} location(s).`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-save'
          });
          self.backToTopic();
        };
        var onFinally = function (){
          self.$vs.loading.close(self.$refs.maindiv.$el);
        };

        self.$ajaxPost(self, "UploadTask/AddEditStandaloneUploadTask", uploadToAddInfo, onSuccess, onFinally);
      }
        else {
          self.$vs.notify({
            title:'Warning',
            color: "warning",
            text: "Please ensure that you have entered a name AND a description for the Upload.",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-info',
            time: 5500
          });
        }
      }
      else{
        self.$vs.notify({
            title:'Warning',
            color: "warning",
            text: "Please ensure that you have selected at least one allow type",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-info',
            time: 5500
          });
      }
    },
    backToTopic() {
      var self = this;
      self.$vs.loading.close(self.$refs.maindiv.$el);
      if (self.isTeacher)
        self.$router.push({ name: 'TeacherBrowseContent', params: { selectedData: self.selectedData, navFromAddContent: true }});  
      else
        self.$router.push({ name: 'BrowseContent', params: { selectedData: self.selectedData, navFromAddContent: true }});
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    getScheduleInformationForTask(taskId){
      var self = this;
      //self.showLoadingOnElement("ref",1,"corners");
      var onSuccess = response =>{
        if(response.data){
          self.useSchedulingFunctionality = true;
          self.fromDate = response.data.fromDate;
          self.toDate = response.data.toDate;
          const fromTime = response.data.fromTime.split(':');
          self.taskBeginTime = fromTime[0]+':'+fromTime[1];
          const toTime = response.data.toTime.split(':');
          self.taskEndTime = toTime[0]+':'+toTime[1];
        }
      }
    
      var onFinally = response =>{
        // if(self.$refs.ref){
        //   //self.$vs.loading.close(self.$refs.ref.$el);
        // }
      }
    
      self.$ajaxGet(self, "UploadTask/GetScheduleInformationForTask/"+taskId , onSuccess, onFinally);
    },
    getStudentExcludedInformationForTask(taskId){
      var self = this;
      var onSuccess = response =>{
        if(response.data){
          self.useVisibilityFunctionality = true;
          let tempStudentIds = response.data;

          self.students.studentsGradeView.forEach(element => {
            let predicate = tempStudentIds.filter(q=> q.studentId == element.studentId);
            if(predicate.length){
              element.checked = false;
            }
            else{
              element.checked = true;
            }
          });
          
          self.students.studentsClassroomView.forEach(element => {
            element.students.forEach(student => {
              let predicate = tempStudentIds.filter(q=> q.studentId == student.studentId);
              if(predicate.length){
                student.checked = false;
              }
              else{
                student.checked = true;
              }
            });
          });
        }
      }
    
      var onFinally = response =>{
      }
    
      self.$ajaxGet(self, "UploadTask/GetExcludedDataForTask/"+taskId , onSuccess, onFinally);
    },
    loadStudentsForVisibilityTable(){
      var self = this;
      var onSuccess = response =>{
        if(response.data){
          self.students = response.data;
          self.useVisibilityFunctionality = true;
        }
        //self.getStudentExcludedInformationForTask(self.uploadTask.id);
      }
    
      var onFinally = response =>{
      }

      var teacherData = {
        Language :self.selectedData.selectedLanguage,
        CourseClasificationId : self.selectedData.selectedGrade.id,//Grade
        CourseId : self.selectedData.selectedSubject.id, //Subject
        ModuleCategoryId : self.selectedData.selectedModule.id, //Module
        ModuleId : self.selectedData.selectedTopic.id,//Topic
        TaskId: self.uploadTask.id
      }

      self.$ajaxPost(self, "Teacher/GetStudentsForVisibilityChecklist" ,teacherData, onSuccess, onFinally);
    },
    handleClassroomClicked(classroom){
      var self = this;
      self.chosenClassroomId = classroom.classroomId;
      self.viewClassroomPopup = true;
    },
  },
  mounted() {
    var self = this;
    self.initValues();
    self.selectedData = self.$route.params.selectedData;
    self.uploadTask = self.$route.params.uploadTask.upload;
    self.isTeacher = self.$route.params.isTeacher;

    self.uploadName = self.uploadTask.name;
    self.uploadDesc = self.uploadTask.description;

    self.allowVideo = self.uploadTask.allowVideo;
    self.allowImage = self.uploadTask.allowImage;
    self.allowDocument = self.uploadTask.allowDocument;
    self.allowAudio = self.uploadTask.allowAudio;
    self.allowMultiple = self.uploadTask.allowMultiple;
    self.allowMultipleSubmissions = self.$route.params.uploadTask.allowMultipleSubmissions;
    self.isAssessment = self.$route.params.uploadTask.isAssessment;
    self.isClasswork = self.$route.params.uploadTask.isClasswork;
    self.getScheduleInformationForTask(self.uploadTask.id);
  }
};
</script>

<style lang="scss">
.main-div {
  width: 65%;
}

@media screen and (max-width: 900px) {
  .main-div {
    width: 100%;
  }
}

.filepond--panel-root {
  border-radius: 0 6px 6px 0;
  background-color: rgba(255, 255, 255, 0) !important;
}

.filepond--drop-label {
  color:rgb(202, 202, 202) !important;
}

#documentname.vs-input--input {
  background: none !important;
  border: 5px solid rgba(192, 196, 212, 0.2) !important;
  border-radius: 20px !important;
  height: 55px !important;
  font-size: 1.4rem !important;
  color: rgb(202, 202, 202) !important;
}

#documentDesc.vs-textarea {
  background: rgba(var(--vs-background),1) !important;
  border-radius: 20px !important;
  border: 5px solid rgba(192, 196, 212, 0.2) !important;
  color: rgb(202, 202, 202) !important;
  font-size: 1rem !important;
  height: 90px !important;
}

// #documentdetails .vs-con-input-label {
//   width: 400px !important;
// }

#documentdetails .focusx.vs-textarea-primary {
  border: 0 solid rgba(0, 0, 0, 0) !important;
}

#documentdetails .vs-textarea-primary {
  border: 0 solid rgba(0, 0, 0, 0) !important;
}

.save__btn {
  border-radius: 15px !important;
}

#back-to-topic_btn {
  border-radius: 15px !important;
}


#schedule-visibility-popup .vs-popup {
  width: 80vw;
  height: 80vw;
}
#schedule-tab-container{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
  margin: 10px;
  transition: all 300ms;
}
#date-pickers{
  display: flex;
  flex-direction: row;
  padding: 10px;
  margin: 10px;
  transition: width 2s, height 4s;
  animation: transitionLeft 1s ;
}
#schedule-tab{
  display: flex;
  //justify-content: center;
  flex-direction: column;
  align-content: center;
}
.time-date-picker-combo{
  padding: 15px;
  margin: 15px;
}

</style>
